import React, { Component } from "react";
import {
  DatePicker,
  Spin,
  message,
  Checkbox,
  Radio,
  Space,
  Select,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { RESEARCH_TYPE } from "../../../../utils/consts";
import { speech_demographics_form_type } from "../../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";

const { Option } = Select;

export default class SymptomOnsetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      loading: false,
      email: "",
      neurostamp_id: "",
      modality_id: "",
      question_list: [],
      field_data: [],

      age_at_diagnosis: "",
      symptom_onset_site: "",
      phenotype: "",
      genetic_status: "",
      date_of_symptom_onset: null,
      date_of_diagnosis: null,
      gene_list: "",
      date_of_birth: null,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.parent_field === "Date of Birth") {
                this.setState({
                  date_of_birth: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.parent_field === "Gene Details") {
                this.setState({
                  gene_list: item.value ? item.value : [],
                });
              }
              if (item.parent_field === "Age at Diagnosis") {
                this.setState({ age_at_diagnosis: item.value });
              }
              if (item.parent_field === "Date of Symptom Onset") {
                this.setState({
                  date_of_symptom_onset: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.parent_field === "Date of Diagnosis") {
                this.setState({
                  date_of_diagnosis: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.parent_field === "Symptom Onset Site") {
                this.setState({ symptom_onset_site: item.value });
              }
              if (item.parent_field === "Phenotype") {
                this.setState({ phenotype: item.value });
              }
              if (item.parent_field === "Genetic Status") {
                this.setState({ genetic_status: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_symptom_onset: date,
    });
  };
  save = () => {
    if (!this.state.date_of_symptom_onset) {
      message.warning("Date of symptom onset is required");
      return;
    }
    if (!this.state.date_of_diagnosis) {
      message.warning("Date of diagnosis is required");
      return;
    }
    if (!this.state.age_at_diagnosis) {
      message.warning("Age at diagnosis is required");
      return;
    }
    if (!this.state.symptom_onset_site) {
      message.warning("Symptom onset site is required");
      return;
    }
    if (!this.state.phenotype) {
      message.warning("Phenotype is required");
      return;
    }
    if (!this.state.genetic_status) {
      message.warning("Genetic status is required");
      return;
    }
    if (
      this.state.genetic_status === "Positive" &&
      this.state.gene_list.length === 0
    ) {
      message.warning("Gene list is required when genetic status is positive");
      return;
    }
    // step 2
    let questions = [
      {
        parent_field: "Age At Diagnosis",
        field: "Age At Diagnosis",
        value: this.state.age_at_diagnosis,
      },
      {
        parent_field: "Date Of Symptom Onset",
        field: "Date Of Symptom Onset",
        value: this.state.date_of_symptom_onset,
      },
      {
        parent_field: "Date Of Diagnosis",
        field: "Date Of Diagnosis",
        value: this.state.date_of_diagnosis,
      },
      {
        parent_field: "Symptom Onset Site",
        field: "Symptom Onset Site",
        value: this.state.symptom_onset_site,
      },
      {
        parent_field: "Phenotype",
        field: "Phenotype",
        value: this.state.phenotype,
      },
      {
        parent_field: "Genetic Status",
        field: "Genetic Status",
        value: this.state.genetic_status,
      },
      {
        parent_field: "Gene List",
        field: "Gene List",
        value:
          this.state.gene_list.length > 0
            ? JSON.stringify(this.state.gene_list)
            : "",
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeGeneList = (e) => {
    let value = e.target.value;
    let tempArr = this.state.gene_list;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ gene_list: newArray });
    } else {
      tempArr.push(value);
      this.setState({ gene_list: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Symptom Onset</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of symptom onset: <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/YYYY"}
                value={this.state.date_of_symptom_onset}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of Diagnosis: <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={(date, dateString) => {
                  let date_of_diagnosis = date;

                  this.setState(
                    {
                      date_of_diagnosis: date,
                    },
                    () => {
                      const dob = dayjs(this.state.date_of_birth);
                      const calculatedAge = dayjs(date_of_diagnosis).diff(
                        dob,
                        "year"
                      );
                      this.setState({
                        age_at_diagnosis: calculatedAge,
                      });
                    }
                  );
                }}
                format={"MM/YYYY"}
                value={this.state.date_of_diagnosis}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
                disabledDate={(current) => current && current > moment()}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Age at Diagnosis: <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="number"
                className="form-control mt-3"
                value={this.state.age_at_diagnosis}
                onChange={(e) =>
                  this.setState({ age_at_diagnosis: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Symptom Onset Site: <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    symptom_onset_site: e.target.value,
                  })
                }
                value={this.state.symptom_onset_site}
              >
                <Space direction="vertical">
                  <Radio value="Swallow">Swallow</Radio>
                  <Radio value="Speech">Speech</Radio>
                  <Radio value="Respiratory">Respiratory</Radio>
                  <Radio value="Leg">Leg</Radio>
                  <Radio value="Arm">Arm</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Phenotype: <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    phenotype: e.target.value,
                  })
                }
                value={this.state.phenotype}
              >
                <Space direction="vertical">
                  <Radio value="Classic">Classic</Radio>
                  <Radio value="Bulbar">Bulbar</Radio>
                  <Radio value="Flail Arm">Flail Arm</Radio>
                  <Radio value="Flail Leg">Flail Leg</Radio>
                  <Radio value="Pyramidal">Pyramidal</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Genetic Status: <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    genetic_status: value,
                    gene_list: [],
                  })
                }
                value={this.state.genetic_status}
                className="col-lg-12"
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select</Option>
                <Option value="Negative">Negative</Option>
                <Option value="Positive">Positive</Option>
                <Option value="Unknown / NA">Unknown / NA</Option>
              </Select>
              {this.state.genetic_status === "Positive" && (
                <div className="form-group mt-3">
                  <label className="mb-2 input-heading">
                    Please list the gene: <span className="text-danger">*</span>
                  </label>
                  <br />
                  <Input
                    type="text"
                    value={this.state.gene_list}
                    onChange={(e) =>
                      this.setState({
                        gene_list: e.target.value,
                      })
                    }
                    placeholder="List gene"
                    className="mt-1"
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    // background: "#b3b3b3",
                    // cursor: "auto",
                  }}
                  className="submit-button"
                  onClick={() => {
                    this.props.set_active_step(1);
                  }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
